import { createSlice } from "@reduxjs/toolkit";
import { InventoryItemResponseDto } from "../../shared/dtos/inventoryItem/InventoryItemResponseDto";
import {
  getInitialCrudState,
  generateCrudReducers,
} from "../utils/crudFactory";

export const inventoryItemSlice = createSlice({
  name: "inventoryItem",
  initialState: getInitialCrudState<InventoryItemResponseDto>(),
  reducers: {
    ...generateCrudReducers<InventoryItemResponseDto>(),
  },
});

export const inventoryItemActions = inventoryItemSlice.actions;
export default inventoryItemSlice.reducer;
